import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import TeamsPage from './pages/TeamsPage';
import TeamPage from './pages/TeamPage';
import AcceptInvite from './pages/AcceptInvite';
import ScrollDemo from './pages/ScrollDemo';
import PublicMinisite from './pages/PublicMinisite';
import MeetingInvite from './pages/MeetingInvite';
import GuestJoinPage from './pages/GuestJoinPage';
import ToastDemo from './pages/ToastDemo';
import BroadcastTest from './components/BroadcastTest';
import { ProtectedRoute, PublicRoute } from './components/Guards';
import { DashboardProvider } from './context/DashboardContext';
import { TeamProvider } from './context/TeamContext';
import { VideoCallProvider, useVideoCall } from './context/VideoCallContext';
import { Toaster, ToastRenderer } from './components/CustomToast';
import { ChatProvider } from './context/ChatContext';
import { ProjectProvider } from './context/ProjectContext';
import { NoticeProvider } from './context/NoticeContext';
import GlobalIncomingCallModal from './components/GlobalIncomingCallModal';
import './App.css';

function AppContent() {
  const { incomingCall, handleAcceptCall, handleRejectCall } = useVideoCall();

  return (
    <div className="App">
      <Toaster position="top-right" reverseOrder={false}>
        {(t) => <ToastRenderer toast={t} />}
      </Toaster>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        {/* <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} /> */}
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route path="/accept-invite/:token" element={<AcceptInvite />} />
        <Route path="/meeting-invite/:token" element={<MeetingInvite />} />
        <Route path="/guest/join/:token" element={<GuestJoinPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardProvider>
                <ChatProvider>
                  <ProjectProvider>
                    <NoticeProvider>
                      <Dashboard />
                    </NoticeProvider>
                  </ProjectProvider>
                </ChatProvider>
              </DashboardProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <ProtectedRoute>
              <TeamsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teams/:teamId"
          element={
            <ProtectedRoute>
              <TeamPage />
            </ProtectedRoute>
          }
        />
        <Route path="/public/minisite/:slug" element={<PublicMinisite />} />
        <Route path="/scroll-demo" element={<ScrollDemo />} />
        <Route path="/toast-demo" element={<ToastDemo />} />
        <Route
          path="/broadcast-test"
          element={
            <ProtectedRoute>
              <BroadcastTest />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="*"
          element={
            localStorage.getItem('token')
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/login" replace />
          }
        />
      </Routes>

      {/* Global Incoming Call Modal */}
      <GlobalIncomingCallModal
        callData={incomingCall}
        onAccept={handleAcceptCall}
        onReject={handleRejectCall}
      />
    </div>
  );
}

function App() {
  return (
    <Router>
      <TeamProvider>
        <VideoCallProvider>
          <AppContent />
        </VideoCallProvider>
      </TeamProvider>
    </Router>
  );
}

export default App;
